import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import "../../assets/css/style.css";
import googleIcon from "../../assets/img/ico/google-icon.svg";

const loginForm = () => {
  return (
    <section className="loginSection">
      <Link to="/" className="back-to-home">
        &#60;
      </Link>
      <h1>Agileom</h1>
      <h4 className="interimH4">Intérim connecté</h4>

      <section className="formSection">
        <form>
          <h2 className="connexionH2">Connexion</h2>
          <div className="emailDiv">
            <label htmlFor="email">E-mail</label>
            <input type="email" id="email" name="email" />
          </div>

          <div>
            <label htmlFor="password">Mot de passe</label>
            <input type="password" id="password" name="password" />
          </div>

          <div className="rememberForgetDiv">
            <span>
              <input type="checkbox" id="rememberMe" name="rememberMe" />
              <label htmlFor="rememberMe">Se souvenir de moi</label>
            </span>
            <a>
              <Link className="nav-links" to="/forgotPassword">
                Mot de passe oublié ?
              </Link>
            </a>
          </div>

          <Link to={"/dashboard-interim"} className="nav-links">
            <button type="submit" className="btn btn-primary">
              Se connecter
            </button>
          </Link>
          <Link to={"/dashboard"} className="nav-links">
            <button type="button" className="btn btn-google">
              <img src={googleIcon} alt="Google logo" /> Continuer avec Google
            </button>
          </Link>
        </form>

        <p className="postuleText">
          Pas encore inscrit ?{" "}
          <a>
            <Link className="nav-links" to="/candidature">
              Je postule
            </Link>
          </a>
        </p>
      </section>
    </section>
  );
};

export default loginForm;
